import { UserProfileDTO } from '@shared/clientTypes/DTOs/UserDTO';
import { EducationalBackground } from '@shared/common';
import { useMemo } from 'react';
import ResumeEducationSection from './ResumeEducationSection/ResumeEducationSection';
import ResumeSchoolSection from './ResumeSchoolSection/ResumeSchoolSection';
import ResumeWorkSection from './ResumeWorkSection/ResumeWorkSection';

interface ResumeTabProps {
  userId: string;
  userProfile?: Partial<UserProfileDTO>;
  isMentorProfile: boolean;
}

const ResumeTab = (props: ResumeTabProps) => {
  const { userId, userProfile, isMentorProfile } = props;

  const { schools, universities } = useMemo(() => {
    const schools: EducationalBackground[] = [];
    const universities: EducationalBackground[] = [];

    userProfile?.educationalBackground?.forEach((educationItem) => {
      if (!!educationItem.school || !!educationItem.gpa) {
        schools.push(educationItem);
      } else {
        universities.push(educationItem);
      }
    });

    return { schools, universities };
  }, [userProfile?.educationalBackground]);

  return (
    <section className="flex flex-col gap-4">
      <ResumeWorkSection
        userId={userId}
        experiences={userProfile?.experiences ?? []}
        isMentorProfile={isMentorProfile}
      />

      <ResumeEducationSection
        userId={userId}
        eduList={universities ?? []}
        isMentorProfile={isMentorProfile}
      />

      <ResumeSchoolSection
        userId={userId}
        eduList={schools ?? []}
        isMentorProfile={isMentorProfile}
      />
    </section>
  );
};

export default ResumeTab;
